module.exports = __webpack_public_path__ + "img/education-banner-catalogue.41cc68fd.svg";